module.exports = __webpack_public_path__ + "img/调研报告_02.8420763f.svg";